/// <reference path="../../../_Ext/Bases/GridBase.ts" />
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class WIPProcessSelectGrid extends _Ext.GridBase<OMS.ProcessMasterRow, any> {
        protected getColumnsKey() { return 'OMS.ProcessMaster'; }
        protected getDialogType() { return <any>OMS.ProcessMasterDialog; }
        protected getIdProperty() { return OMS.ProcessMasterRow.idProperty; }
        protected getLocalTextPrefix() { return OMS.ProcessMasterRow.localTextPrefix; }
        protected getService() { return OMS.ProcessSelectService.baseUrl; }
        protected getInitialTitle() { return null; };
        //protected useViewMode() { return true; } 
      
        constructor(container: JQuery,options) {
            super(container, options);

            (this.view.params as ProcessRequest).ProcessTypeId = [142]; 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            this.slickGrid.setOptions({ rowHeight: 30 });

           
            return this;
        }

        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);



            return grid;
        }

        protected createToolbarExtensions(): void {
            super.createToolbarExtensions()

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): OMS.ProcessMasterRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
             return true;
        }

    } 
}